import { Component, OnInit, Output, Input,EventEmitter, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';
// import * as UserDataConfig from '../config/user-data.config';
// import { AlertModal } from '../../model/alert';
// import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { QuoteDataCaptureService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss']
})
export class AddressSearchComponent implements OnInit, OnDestroy {

  public resultAddress: any[];
  public suggestiontext: any[];
  searchTerm$ = new Subject<string>();
  isListAddressEnabled = true;
  noRecordFound = true;
  private subscription;
  public contentData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSelecteAddress: EventEmitter<any> = new EventEmitter<any>();

  constructor(private quoteDatacaptureService: QuoteDataCaptureService,
              private eRef: ElementRef,
              private activatedRoute: ActivatedRoute
              ) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.addressSearch;
    // quoteDatacaptureService.search(this.searchTerm$)
    // .subscribe(result => this.results = results['results']);
  }

  ngOnInit() {
   this.subscription = this.searchTerm$.map(res => res).debounceTime(200).subscribe(res => {
        this.isListAddressEnabled = true;
        if (res.length >= 1) {
          this.quoteDatacaptureService.searchAddress(res)
          .subscribe((results: any[] ) => {
            this.resultAddress = results;
            if (results !== undefined && this.resultAddress.length >= 1) {
              this.noRecordFound = false;
              this.suggestiontext = results.map(r => r.suggestion);
            } else {
              this.quoteDatacaptureService.searchDummyAddress()
              .subscribe(resdummy => {
                this.noRecordFound = true;
                this.suggestiontext = resdummy.map(r => r.suggestion);
              }
                );
            }
          });
        } else {
          this.suggestiontext = null;
        }
    }
 );
  }

onSelectAddress(selectedAddress) {
  if (!this.noRecordFound) {
    const formatUrl = this.resultAddress.find(a => a.suggestion === selectedAddress);
    this.quoteDatacaptureService.getFormattedAddress(formatUrl['format']).subscribe(
      result => this.onSelecteAddress.emit(result)
    );
  }
  }

  @HostListener('document:click', ['$event'])
    public clickout(event) {
      if (this.eRef.nativeElement.contains(event.target)) {
      this.isListAddressEnabled = true;
    } else {
      this.isListAddressEnabled = false;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
